import util from "../util";

const doGet = (context, url, cbResolve) => {
  const headers = util.getAuthHeader()
  return new Promise((resolve, reject) => {

    context.axios.get(url, { headers }).then((response) => {

      if (cbResolve)
        cbResolve()

      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(context, error.response.data.message)
        reject(error.response)
      }
      else reject(error)

    });
  })
}

const doGet2 = (context, url, options) => { // Cambiamos el 3er parámetro a 'options'
  const headers = util.getAuthHeader();

  // Combinamos los encabezados de autenticación con cualquier otra opción que se pase
  const config = {
    ...options, // Aquí se incluirá { responseType: 'blob' } cuando se necesite
    headers
  };

  return new Promise((resolve, reject) => {
    context.axios.get(url, config).then((response) => {
      // Si se solicitó un blob (como en tu descarga), es crucial resolver la
      // respuesta COMPLETA, para que el .then() pueda verificar response.status.
      if (options && options.responseType === 'blob') {
        resolve(response);
      } else {
        // Para las llamadas GET normales que esperan JSON, mantenemos el comportamiento anterior.
        resolve(response.data);
      }
    }).catch(error => {
      if (error.response) {
        // Manejo mejorado de errores cuando se espera un blob pero se recibe un error JSON
        if (error.response.data instanceof Blob && error.response.data.type === "application/json") {
          const reader = new FileReader();
          reader.onload = function() {
            const errorJson = JSON.parse(reader.result);
            util.showDialogError(context, errorJson.message || "Error en la descarga");
          }
          reader.readAsText(error.response.data);
          reject(error.response);
        } else {
          util.showDialogError(context, error.response.data.message || "Error en el servidor");
          reject(error.response);
        }
      } else {
        reject(error);
      }
    });
  });
};

const doPost = (context, url, body, cbResolve) => {
  const headers = util.getAuthHeader()
  return new Promise((resolve, reject) => {

    context.axios.post(url, body, { headers }).then((response) => {

      if (cbResolve)
        cbResolve()

      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(context, error.response.data.message)
        reject(error.response)
      }
      else reject(error)

    });
  })
}

const doPostMultipart = (context, url, formData, cbResolve) => {
  const headers = {
    ...util.getAuthHeader(),
    'Content-Type': 'multipart/form-data'
  };

  return new Promise((resolve, reject) => {
    context.axios.post(url, formData, { headers })
      .then(response => {
        if (cbResolve) cbResolve();
        resolve(response.data);
      })
      .catch(error => {
        if (error.response) {
          util.showDialogError(context, error.response.data.message);
          reject(error.response);
        } else {
          reject(error);
        }
      });
  });
};

const doPostDonwload = (context, url, body, nameFile, cbResolve) => {
  const headers = util.getAuthHeader()
  return new Promise((resolve, reject) => {

    context.axios.post(
      url,
      body, {
        headers,
        responseType: 'blob'
      }).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      if (body.extExport) {
        link.setAttribute('download', `${nameFile}.${body.extExport}`);
      } else {
        link.setAttribute('download', `${nameFile}`);
      }


      document.body.appendChild(link);
      link.click();
      console.log(response.data)
      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(context, "Ocurrió un error al descargar el archivo")

        const reader = new FileReader();
        reader.onload = function() {
          const errorMessage = reader.result;
          console.error('Error del servidor:', errorMessage);
          util.showDialogError(context, "Error al descargar: " + errorMessage);
        };
        reader.readAsText(error.response.data);

        reject(error.response)
      }
      else reject(error)

    });

  })
}

const doPostDonwload2 = (context, url, body, nameFile, cbResolve) => {
  const headers = util.getAuthHeader()
  return new Promise((resolve, reject) => {

    context.axios.post(url, body.data, { headers, responseType: 'blob' }).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      if (body.extExport) {
        link.setAttribute('download', `${nameFile}.${body.extExport}`);
      } else {
        link.setAttribute('download', `${nameFile}`);
      }


      document.body.appendChild(link);
      link.click();
      console.log(response.data)
      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(context, "Ocurrió un error al descargar el archivo")

        const reader = new FileReader();
        reader.onload = function () {
          console.log(JSON.parse(reader.result));
        }
        reader.readAsText(error.response.data);

        reject(error.response)
      }
      else reject(error)

    });

  })
}

const doPut = (context, url, body, cbResolve) => {
  const headers = util.getAuthHeader()
  return new Promise((resolve, reject) => {

    context.axios.put(url, body, { headers }).then((response) => {

      if (cbResolve)
        cbResolve()

      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(context, error.response.data.message)
        reject(error.response)
      }
      else reject(error)

    });
  })
}

const doPatch = (context, url, body, cbResolve) => {
  const headers = util.getAuthHeader()
  return new Promise((resolve, reject) => {

    context.axios.patch(url, body, { headers }).then((response) => {

      if (cbResolve)
        cbResolve()

      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(context, error.response.data.message)
        reject(error.response)
      }
      else reject(error)

    });
  })
}

const doDelete = (context, url, cbResolve) => {
  const headers = util.getAuthHeader()
  return new Promise((resolve, reject) => {

    context.axios.delete(url, { headers }).then((response) => {

      if (cbResolve)
        cbResolve()

      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(context, error.response.data.message)
        reject(error.response)
      }
      else reject(error)

    });
  })
}

export default {
  doGet,
  doGet2,
  doPost,
  doPostMultipart,
  doPostDonwload,
  doPostDonwload2,
  doPut,
  doPatch,
  doDelete
};



// WEBPACK FOOTER //
// ./src/api/methods.js